import { Constants, FilteredCreditApplication } from '@applyonline/shared'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ManageCoappButton } from '../../../components'
import { trackEvent } from '../../../services/trackingEvents'
import { ETrackedEvents } from '../../../types/tracking'
import DeclinedCancelAppButton from './DeclinedCancelAppButton'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    trackEvent(ETrackedEvents.QualifDeclined, creditApp)
  }, [creditApp])

  return (
    <main className="form-section" style={{ textAlign: 'center' }}>
      <h4 className="subtitle">{t('common.financeApplication')}</h4>
      <p>
        {t(`finalDecision.refusedHasCoApplicant.${creditApp.coapplicant !== null}`, {
          forStep: t('common.qualified'),
        })}
        {creditApp.coapplicant === null && !creditApp.finalDecision.isHardDecline && !Constants.MerchantsThatForbidHavingCoapplicants.includes(creditApp.merchantId) ? t('finalDecision.canAddCoapplicant') : <Trans i18nKey={"finalDecision.noCoapplicantAllowed"} />}
      </p>
      <div className="btn-group mobile-reversed space-between" style={{ marginTop: '16px' }}>
        <DeclinedCancelAppButton creditApp={creditApp} cancelEventName={ETrackedEvents.WithdrewAfterQualif} />
        <ManageCoappButton creditAppId={creditApp.id} useChangeLabel={creditApp.coapplicant !== null} merchantId={creditApp.merchantId} isHardDecline={creditApp.finalDecision.isHardDecline} />
      </div>
    </main>
  )
}

export default DeclinedDecisionForm
